(function(){
    angular
        .module('app')
        .directive('ngAddckeditor', addckeditor);

        addckeditor.$inject = ['$timeout','$uibModal'];
        function addckeditor($timeout,$uibModal){
            return {
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                    //console.log(scope);
                    var name = $element.attr("id");
                    scope.modelText = {}
                    scope.makeXMLHttpRequest = function(url, data, callback) {
                        var request = new XMLHttpRequest();
                        request.onreadystatechange = function() {
                            if (request.readyState == 4 && request.status == 200) {
                                callback('upload-ended', request.responseText);
                            }
                        };
              
                        request.upload.onloadstart = function() {
                            callback('Upload started...');
                        };
              
                        request.upload.onprogress = function(event) {
                            callback('Upload Progress ' + Math.round(event.loaded / event.total * 100) + "%");
                        };
              
                        request.upload.onload = function() {
                            callback('progress-about-to-end');
                        };
              
                        request.upload.onload = function() {
                            callback('progress-ended');
                        };
              
                        request.upload.onerror = function(error) {
                            callback('Failed to upload to server');
                            console.error('XMLHttpRequest failed', error);
                        };
              
                        request.upload.onabort = function(error) {
                            callback('Upload aborted.');
                            console.error('XMLHttpRequest aborted', error);
                        };
              
                        request.open('POST', url);
                        request.send(data);
                    }
                    scope.uploadToServer = function(blob, isAudioOnly,callback) {
                            var url = URL.createObjectURL(blob);
                            //console.log(url);
                        //var blob = record.blob;
            
                        //console.log("blob",blob);
                        var fileType = blob.type.split('/')[0] || 'audio';
                        var fileName = (Math.random() * 1000).toString().replace('.', '');
            
                        if (fileType === 'audio') {
                            fileName += '.' + (!!navigator.mozGetUserMedia ? 'mp3' : 'mp3');
                        } else {
                            fileName += '.webm';
                        }
            
                        // create FormData
                        var formData = new FormData();
                        formData.append(fileType + '-filename', fileName);
                        formData.append(fileType + '-blob', blob);
                        formData.append('isAudioOnly', isAudioOnly);

            
                        //callback('Uploading ' + fileType + ' recording to server.');
            
                        // var upload_url = 'https://your-domain.com/files-uploader/';
                        var upload_url = '/backend/altcrm/content/saveaudio';
            
                        // var upload_directory = upload_url;
                        var upload_directory = 'uploads/';
            
                        scope.makeXMLHttpRequest(upload_url, formData, function(progress,response) {
                            if (progress !== 'upload-ended') {
                                //callback(progress);
                                return;
                            }
                            console.log("response",response);
                            try {
                                responseData = JSON.parse(response);
                            } catch (e) {
                                console.error('Error parsing response:', e);
                                responseData = null;
                            }
            
                            callback('ended', fileName,responseData);
            
                            // to make sure we can delete as soon as visitor leaves
                            //listOfFilesUploaded.push(upload_directory + fileName);
                        });
                    }
                    //console.log(name);

                    var ck = CKEDITOR.replace(name,{
                        enterMode : CKEDITOR.ENTER_P,
                        toolbar : 'Basic', /* this does the magic */
                    })
                   
                    ck.on('change', updateModel);
                    ck.on('key', updateModel);
                    ck.on('dataReady', updateModel);
                    ck.on( 'mode', function() {
                        // Debugger.log('ckeditor mode change: '+ this.mode);
                        if ( this.mode == 'source' ) {
                            var editable = ck.editable();
                            editable.attachListener( editable, 'input', function() {
                                // Debugger.log('ckeditor source input change');
                                 ck.fire('change');
                            } );
                        }
                    } );
                    if (!CKEDITOR.plugins.registered['alt120_voice']) {
                        CKEDITOR.plugins.add('alt120_voice', {
                            icon: 'image',
                            init: function (editor) {
                                editor.addCommand('alt120_voice', {
                                    exec: function (editor) {
                                        scope.isAudioOnly = false;
                                        var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
                                        if(SpeechRecognition){
                                            scope.recognition = new SpeechRecognition();
                                        }else{
                                            scope.recognition = {};
                                            scope.isAudioOnly = true;
                                        }
                                        scope.recognition.continuous = true;
                                        scope.recognition.interimResults = true;
                                        scope.recognition.lang = 'es-ES';

                                        var modalInstance = $uibModal.open({
                                            template: `
                                                <div class="modal-header">
                                                    <h3 class="modal-title">Transcripción en curso</h3>
                                                </div>
                                                <div class="modal-body">
                                                    <div id="transcription">[[transcription]]</div>
                                                    <div id="pretext">[[preText]]</div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button class="btn btn-primary" ng-click="stopRecording()">Detener grabación</button>
                                                </div>
                                            `,
                                            controller: function ($scope, $uibModalInstance) {
                                                $scope.transcription = '';
                                                $scope.preText = '';
                                                $scope.rtcSession = {
          
                                                    audio: true,
                                                };
                                                $scope.recordRTC;
                                                $scope.recorder;
                                                navigator.getUserMedia($scope.rtcSession, (mediaStream) => {
                                                    var audio_context = new AudioContext;
                                                    var inputPoint = audio_context.createMediaStreamSource(mediaStream);
                                                    $scope.recorder = new Recorder(inputPoint,{numChannels:1});
                                                    $scope.recorder.record();
                                    
                                                }, () => {
                                                    console.error('An error has occurred while attempting to get user media.');
                                                });
                                                scope.recognition.onresult = function (event) {
                                                    var frase = "";
                                                      if(frase!=""){
                                                         frase+=" ";
                                                      }
                                                      $scope.preText = "";
                                                      for (var i = event.resultIndex; i < event.results.length; i++) {
                                          
                                                        for (var ind = 0; ind < event.results[i].length; ind++) {
                                                          if (event.results[i].isFinal) {
                                                            //frase  += event.results[i][0].transcript;
                                                            frase+=event.results[i][ind].transcript;
                                                          }else{
                                                            $scope.preText += event.results[i][ind].transcript;
                                                          }
                                                        }
                                                      }
                                                      $timeout(function(){
                                                        $scope.transcription = $scope.transcription+frase;
                                                        console.log("frase",$scope.transcription);
                                                      })
                                                  };
                                                $scope.stopRecording = function () {
                                                    if(!scope.isAudioOnly){
                                                        scope.recognition.stop();
                                                    }
                                                    $uibModalInstance.close();
                                                    $scope.recorder.stop();

                                                    $scope.recorder.exportWAV(function(blob){
                                                    //console.log("STOP REC");
                                                    if($scope.transcription=='' && $scope.preText==''){
                                                        scope.isAudioOnly = true;
                                                    }
                                                    scope.uploadToServer(blob,scope.isAudioOnly,function(code,fileName,data){
                                                        //callback
                                                        $timeout(function(){
                                                            var html = '<br/><audio controls>'+
                                                            '<source src="/backend/uploads/audios/'+fileName+'" type="audio/mpeg">'+
                                                            'Tu navegador no soporta el elemento de audio.'+
                                                            '</audio>';
                                                            if(scope.isAudioOnly){
                                                                html += "<br/>"+data.texto;
                                                            }
                                                            editor.insertHtml(html);

                                                            //console.log("filename",fileName);
                                                            /*if(typeof(modelText.files)=='undefined'){
                                                                modelText.files = [];
                                                            }
                                                            modelText.files.push({analitica:'',fileName:fileName})*/
                                                        })
                                                        
                                                    })
                                                    });
                                                    editor.insertHtml($scope.transcription+$scope.preText);

                                                };
                                            }
                                        });

                                        scope.recognition.onend = function (event) {
                                            //console.log("ONEND",event);
                                            if(scope.audioRes && !scope.isAudioOnly){
                                                //scope.modelText+=" ";
                                                scope.recognition.start();
                                            }
                                        };
                                        scope.recognition.onerror = function (event) {
                                            //console.log("ONERROR",event);
                                            
                                        };

                                        scope.recognition.onaudiostart = function() {
                                            //console.log('Audio capturing started');
                                        }
                                        scope.recognition.onaudioend = function(event) {
                                            //console.log('Audio capturing stop',event);
                                        }
                                       
                                        if(!scope.isAudioOnly){
                                            scope.recognition.start();
                                        }
                                    }
                                });
                                editor.ui.addButton('alt120_voice', { icon:'/backend/img/audio.png',label: 'Upload', command: 'alt120_voice', toolbar: 'alt120_voice' });
                            }
                        });
                    }
                    ck.on( 'instanceReady', function( ev ) {
                        editor = ev.editor;

                        scope.$watch(function() {
                            return element.attr('readonly'); 
                        }, function(newValue){
                            if(newValue){
                                editor.setReadOnly( true );
                            }else{
                                editor.setReadOnly( false );
                            }
                        });
                    });
                     ngModel.$render = function () {
                        var newValue = ngModel.$viewValue;
                        ck.setData(newValue);
                        //console.log(newValue)
                    };

                    function updateModel() {
                        //console.log("UPDATE CKEDITOR");
                        ngModel.$setViewValue(ck.getData());
                        /*$timeout(function(){

                        ck.fire('change');
                        })*/

                        //scope.$apply(function() {
                          //console.log(ck);
                          //console.log(ck.getData());
                            //ngModel.$setViewValue(ck.getData());
                        //});
                    }
                });
            }
          }
      }
})();